var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cs-card',{staticClass:"large-content-card"},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }